module.exports = __webpack_public_path__ + "static/images/components/BaseBonusInfoTable/images/dots.d3f86a3b.png";


//////////////////
// WEBPACK FOOTER
// ./components/BaseBonusInfoTable/images/dots.png
// module id = 2499
// module chunks = 11